// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useDynamicTranslation } from "@/hooks/useDynamicTranslation";

export function Agreement() {
  const { t } = useDynamicTranslation("signup");

  const handleLinkClick = (event: any) => {
    event.preventDefault();
    const newTab = window.open("/agreement", "_blank");
    newTab.focus();
  };

  return (
    <a
      href="/agreement"
      onClick={handleLinkClick}
      style={{ color: "inherit", textDecoration: "none" }}
    >
      <InfoOutlinedIcon sx={{ verticalAlign: "middle", mr: 1 }} />
      {t("corporateCustomerAgreement")}
    </a>
  );
}
